package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.times
import pl.decks.personal.components.animations.HeartbeatPulseAnimation
import pl.decks.personal.components.layouts.site.SiteLayoutStylesheet
import pl.decks.personal.pages.ievp.IEVPStylesheet
import pl.decks.personal.styles.SiteLayout

@Composable
fun TriggerDevForeword() = Column(
    modifier = SiteLayoutStylesheet.Page.Content.toModifier()
        .padding(left = IEVPStylesheet.Vars.contentPaddingLeft.value(), top = SiteLayout.Space.Medium),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    CoverLetterText(
        "Pulled the trigger? Let the bullet stroll for a while.",
        "I research my targets and don't fire blindly - you are on a lookout for a Backend Engineer. I'm a Data Engineer by title, but most of my work has been tooling and infrastructure for other developers.",
        "From the posting, Trigger.dev seeks a capable generalist. I've dealt with a fair share of infrastructure, product, software and data problems and am honest about my shortcomings. You'll find both on this page.",
        "Reflecting, a lot of what I've done traces back to Open Source. Having worked for proprietary software companies, sharing the results openly has never been only my call to make. Honestly, that pisses me off and this project is an attempt to give back to the community. I search for a culture to learn to do that better.",
        "So, if the full Python support from your feedback feed is urgent or the data struggles are pressing, we might be a fit. If we are not, I already used Trigger.dev for a personalized recap at the bottom. That alone makes the shot worth it. ",
    )
    Box(Modifier.size(6.6.cssRem), contentAlignment = Alignment.Center) {
        Image(
            "/images/evp/logo/trigger_dev_symbol.svg",
            modifier = Modifier.width(6.cssRem)
                .rotate(60.deg)
                .animation(
                    HeartbeatPulseAnimation.Frames.toAnimation(
                        duration = 3 * TransitionDurationVars.UltraSlow.value(),
                        timingFunction = AnimationTimingFunction.EaseInOut,
                        iterationCount = AnimationIterationCount.Infinite,
                    )
                )
        )
    }
}
